import { render, staticRenderFns } from "./TaskAssignedDueNotification.vue?vue&type=template&id=de639e46&scoped=true&"
import script from "./TaskAssignedDueNotification.vue?vue&type=script&lang=js&"
export * from "./TaskAssignedDueNotification.vue?vue&type=script&lang=js&"
import style0 from "./TaskAssignedDueNotification.vue?vue&type=style&index=0&id=de639e46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de639e46",
  null
  
)

export default component.exports